// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wFiab","importantInfo":"styles_importantInfo__10jIb"};